import { render } from "./Servicedetails.vue?vue&type=template&id=6a83c1a0"
import script from "./Servicedetails.vue?vue&type=script&lang=js"
export * from "./Servicedetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__